import styled from 'styled-components';

import MuiButton from '@material-ui/core/Button';

export const ReplayButton = styled(MuiButton).attrs(() => ({
  color: 'secondary',
  size: 'small',
  variant: 'contained'
}))``;
